export default __webpack_public_path__ + "static/media/slider-8.bffa3af0.png";